import { Box, xxlBumps } from '@wrisk/ui-components'
import React, { FunctionComponent, useState } from 'react'

import {
  TKey,
  useWriskTranslation,
} from '../../../../infrastructure/internationalisation'
import {
  CheckoutMethod,
  isCheckoutMethod,
  PaymentScheduleConfig,
} from '../../../../state/configuration'
import { FullPage } from '../../../templates'
import { useProduct } from '../../productContext'
import { ProposalSidebarPricing } from '../pricing'
import { useProposal } from '../ProposalProvider'
import {
  CheckoutCard,
  CheckoutDirectDebit,
  CheckoutDual,
  CheckoutMethods,
} from './components'

const tKey = TKey('pages.checkout-user')

export interface CheckoutUserProps {
  config: PaymentScheduleConfig
}

export const CheckoutPage: FunctionComponent<CheckoutUserProps> = ({ config }) => {
  const { t } = useWriskTranslation()

  const { proposal } = useProposal()
  const { product } = useProduct()

  const [checkoutMethod, setCheckoutMethod] = useState<CheckoutMethod>(() => {
    const context = new URLSearchParams(window.location.search).get('context')
    return isCheckoutMethod(context) ? context : config.checkoutMethods[0]
  })

  const paymentComponent = (() => {
    switch (checkoutMethod) {
      case 'CARD':
        return <CheckoutCard config={config} />
      case 'DIRECT_DEBIT':
        return <CheckoutDirectDebit config={config} checkoutMethod={checkoutMethod} />
      case 'DUAL':
        return <CheckoutDual config={config} checkoutMethod={checkoutMethod} />
    }
  })()

  return (
    <FullPage pageId='checkout-page' header={t(tKey('header'))}>
      <Box display='flex' rowGap={xxlBumps} flexDirection='column' width={1}>
        <Box variant='raised' width={1}>
          <ProposalSidebarPricing
            proposal={proposal}
            product={product}
            toggleable={false}
          />
        </Box>

        {config.checkoutMethods.length > 1 && (
          <CheckoutMethods
            options={config.checkoutMethods}
            value={checkoutMethod}
            onChange={setCheckoutMethod}
          />
        )}

        {paymentComponent}
      </Box>
    </FullPage>
  )
}
